import * as React from "react";
const SvgNchsteSeite = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="NächsteSeite">
    <path
      fill="currentColor"
      d="m52.35 226.74 158.8-91.69c5.43-3.14 5.43-10.98 0-14.11L52.35 29.26c-5.43-3.14-12.22.78-12.22 7.06v183.37c0 6.27 6.79 10.19 12.22 7.06Zm2.77-178.56L193.37 128 55.12 207.82z"
    />
  </svg>
);
export default SvgNchsteSeite;
